import React from "react";

const Footer = () => {
    return (
        <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 border-top bg-dark text-light mt-auto">
            <div className="container text-center">
                <span>© 2024 Company, Inc</span>
            </div>
        </footer>
    );
};

export default Footer;
